module.exports = {"master":3,"branch":0,"item":10}


//////////////////
// WEBPACK FOOTER
// ./src/utils/version.json
// module id = aKXX
// module chunks = 49